// Maison Monravel (02/10/2026) : le formulaire n'existe que dans le pied de page ; « ?. » évite l'erreur sur les pages sans pied de page, modèle page.forms et page mot de passe.
// Maison Monravel (04/10/2026) : protection anti-robots du formulaire du pied de page.
// Un envoi est ignoré (le message de remerciement s'affiche, mais rien n'est envoyé à Klaviyo) si :
// - le champ piège invisible « website » est rempli (les humains ne le voient pas) ;
// - le navigateur est piloté par un script (navigator.webdriver) ;
// - le user-agent commence par un guillemet (signature des robots observés depuis novembre 2025) ;
// - le formulaire est envoyé moins de 3 secondes après le chargement de la page.
var mmFormReadyAt = Date.now();
(function () {
    var form = document.getElementById('klaviyo-subscribe-form');
    if (!form || form.querySelector('input[name="website"]')) return;
    var trap = document.createElement('input');
    trap.type = 'text';
    trap.name = 'website';
    trap.tabIndex = -1;
    trap.autocomplete = 'off';
    trap.setAttribute('aria-hidden', 'true');
    trap.style.cssText = 'position:absolute!important;left:-10000px!important;top:auto!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important;';
    form.appendChild(trap);
})();

function mmLooksLikeBot(form) {
    try {
        var trap = form.querySelector('input[name="website"]');
        if (trap && trap.value) return true;
        if (navigator.webdriver) return true;
        if ((navigator.userAgent || '').charAt(0) === '"') return true;
        if (Date.now() - mmFormReadyAt < 3000) return true;
    } catch (err) {}
    return false;
}

document.getElementById('klaviyo-subscribe-form')?.addEventListener('submit', async function(e) {
    e.preventDefault();

    const form = e.target;
    const emailInput = form.querySelector('input[name="email"]');
    const phoneInput = form.querySelector('input[name="phone"]');
    const consentInput = form.querySelector('input[name="consent"]');
    const consentLabel = form.querySelector('.consent-checkbox');
    const submitBtn = form.querySelector('.subscribe-btn');
    const msgEl = document.getElementById('subscribe-message');
    
    const email = emailInput.value.trim();
    const phone = phoneInput.value.trim();
    const consentGiven = consentInput.checked;

    // Translation object - you can populate this from Shopify translations
    const translations = {
        fr: {
            emailError: 'Veuillez saisir une adresse e-mail valide.',
            phoneError: 'Veuillez saisir un numéro de téléphone valide (ex. +33155552671).',
            consentError: 'Vous devez accepter de recevoir nos communications.',
            subscribing: 'Inscription...',
            subscribe: 'S\'inscrire',
            thankYou: 'Merci pour votre inscription !',
            subscriptionFailed: 'L\'inscription a échoué. Veuillez réessayer.',
            networkError: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.'
        },
        en: {
            emailError: 'Please enter a valid email address.',
            phoneError: 'Please enter a valid phone number (e.g. +33155552671).',
            consentError: 'You must agree to receive our communications.',
            subscribing: 'Subscribing...',
            subscribe: 'Subscribe',
            thankYou: 'Thank you for subscribing!',
            subscriptionFailed: 'Subscription failed. Please try again.',
            networkError: 'Network error. Please check your connection and try again.'
        }
    };

    // Detect language (you might want to get this from Shopify's locale)
    const currentLang = document.documentElement.lang || 'fr';
    const t = translations[currentLang] || translations.fr;

    // Clear previous messages and errors
    msgEl.innerHTML = '';
    emailInput.classList.remove('error');
    phoneInput.classList.remove('error');
    consentLabel.classList.remove('error');

    // Validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?[1-9]\d{9,14}$/;
    let errors = [];

    if (!email || !emailRegex.test(email)) {
        errors.push(t.emailError);
        emailInput.classList.add('error');
    }

    if (phone && !phoneRegex.test(phone)) {
        errors.push(t.phoneError);
        phoneInput.classList.add('error');
    }

    if (!consentGiven) {
        errors.push(t.consentError);
        consentLabel.classList.add('error');
    }

    if (errors.length > 0) {
        msgEl.innerHTML = `
            <div class="KlaviyoErrorResponse">
                ${errors.join(' ')}
            </div>
        `;
        return;
    }

    // Protection anti-robots : même message de remerciement, mais aucun envoi à Klaviyo
    if (mmLooksLikeBot(form)) {
        msgEl.innerHTML = `
            <div class="KlaviyoformResponse">
                <div class="responseh1">${t.thankYou}</div>
            </div>
        `;
        const mmWrapper = form.querySelector('.formWrapper');
        if (mmWrapper) mmWrapper.style.display = 'none';
        return;
    }

    // Show loading state
    submitBtn.disabled = true;
    submitBtn.textContent = t.subscribing;
    form.classList.add('loading');

    try {
        // Klaviyo configuration
        const KLAVIYO_COMPANY_ID = 'UcZUBb';
        const LIST_ID = 'VuFh6G';
        
        // Build profile attributes
        const profileAttributes = {
            email: email,
            properties: {
                source: 'shopify_newsletter',
                newsletter_signup_date: new Date().toISOString(),
                signup_source_url: window.location.href,
                signup_page_title: document.title,
                locale: navigator.language || 'en',
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
                consent_given: true,
                consent_date: new Date().toISOString(),
                consent_source: 'newsletter_signup'
            }
        };

        // Add phone if provided
        if (phone) {
            profileAttributes.phone_number = phone;
            profileAttributes.properties.phone_provided = true;
        }

        // Build the payload for Klaviyo's client-side subscription API
        const subscriptionPayload = {
            data: {
                type: 'subscription',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: profileAttributes
                        }
                    }
                },
                relationships: {
                    list: {
                        data: {
                            type: 'list',
                            id: LIST_ID
                        }
                    }
                }
            }
        };

        // Make the subscription API call
        const subscriptionResponse = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_COMPANY_ID}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
                'Revision': '2025-04-15'
            },
            body: JSON.stringify(subscriptionPayload)
        });

        if (subscriptionResponse.ok) {
            // Track the newsletter signup event
            await trackNewsletterSignup(email, phone, KLAVIYO_COMPANY_ID, consentGiven);
            
            // Success
            msgEl.innerHTML = `
                <div class="KlaviyoformResponse">
                    <div class="responseh1">${t.thankYou}</div>
                </div>
            `;
            form.querySelector('.formWrapper').style.display = 'none';
        } else {
            // Handle Klaviyo API errors
            const errorData = await subscriptionResponse.json();
            const errorMessage = errorData.errors?.[0]?.detail || t.subscriptionFailed;
            
            msgEl.innerHTML = `
                <div class="KlaviyoErrorResponse">
                    ${errorMessage}
                </div>
            `;
        }

    } catch (error) {
        // Handle network errors
        console.error('Subscription error:', error);
        msgEl.innerHTML = `
            <div class="KlaviyoErrorResponse">
                ${t.networkError}
            </div>
        `;
    } finally {
        // Reset button state
        submitBtn.disabled = false;
        submitBtn.textContent = t.subscribe;
        form.classList.remove('loading');
    }
});

// Function to track newsletter signup event
async function trackNewsletterSignup(email, phone, companyId, consentGiven) {
    try {
        const eventPayload = {
            data: {
                type: 'event',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: email
                            }
                        }
                    },
                    metric: {
                        data: {
                            type: 'metric',
                            attributes: {
                                name: 'SMB Newsletter Signup'
                            }
                        }
                    },
                    properties: {
                        source: 'shopify_newsletter',
                        signup_date: new Date().toISOString(),
                        page_url: window.location.href,
                        page_title: document.title,
                        phone_provided: !!phone,
                        user_agent: navigator.userAgent,
                        referrer: document.referrer || 'direct',
                        locale: navigator.language || 'en',
                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
                        consent_given: consentGiven,
                        consent_date: new Date().toISOString(),
                        consent_source: 'newsletter_signup'
                    }
                }
            }
        };

        const eventResponse = await fetch(`https://a.klaviyo.com/client/events?company_id=${companyId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
                'Revision': '2025-04-15'
            },
            body: JSON.stringify(eventPayload)
        });

        if (eventResponse.ok) {
            console.log('Newsletter signup event tracked successfully');
        } else {
            console.log('Event tracking failed, but subscription was successful');
        }

    } catch (error) {
        console.log('Event tracking error (subscription still successful):', error);
    }
}

// Mobile button functionality (if needed)
document.addEventListener('DOMContentLoaded', function () {
    const mobileBtn = document.querySelector('.mobilebtn');
    const newsletterBox = document.querySelector('.newsletter-box');
    const centerWrapper = document.querySelector('.center-wrapper');
    
    if (mobileBtn) {
        mobileBtn.addEventListener('click', function (e) {
            e.preventDefault();
            newsletterBox.classList.add('active');
            centerWrapper.classList.add('hidden');
        });
    }
});